if (!customElements.get('localization-form')) {
  customElements.define('localization-form', class LocalizationForm extends SelectDropdown {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        select: this.querySelector('.xselect select'),
        xselect: this.querySelector('.xselect'),
        label: this.querySelector('.xselect__label'),
      };
    }

    changeOption(target) {
      if (target.hasAttribute('disabled')) {
        this.close(target.closest('.xselect'));
        return;
      }

      // Call parent changeOption to handle visual updates and select element
      super.changeOption(target);

      const selectedValue = target.dataset.option || target.getAttribute('value');
      
      // Update hidden input
      if (this.elements.input) {
        this.elements.input.value = selectedValue;
      }

      // Update label
      if (this.elements.label) {
        const labelFlag = this.elements.label.querySelector('.xselect__label__flag');
        const labelText = this.elements.label.querySelector('.xselect__label__text');
        const optionFlag = target.querySelector('.xselect__option__flag');
        const optionText = target.querySelector('.xselect__option__text');
        
        if (labelFlag && optionFlag) {
          labelFlag.innerHTML = optionFlag.innerHTML;
        }
        
        if (labelText && optionText) {
          labelText.textContent = optionText.textContent.trim();
        } else {
          // Fallback for backwards compatibility
          this.elements.label.textContent = target.textContent.trim();
        }
      }

      // Close dropdown
      this.close(target.closest('.xselect'));

      // Submit form
      const form = this.querySelector('form');
      if (form) {
        form.submit();
      }
    }
  });
}
